import { PlusOutlined, DeleteOutlined, EditOutlined, ImportOutlined, DownloadOutlined, CloseCircleTwoTone, CheckCircleTwoTone, RedoOutlined, LoadingOutlined } from '@ant-design/icons'
import { Col, Row, List, Button, Spin, Modal, PageHeader, Table } from "antd";
import React from "react";
import { ConfigOpenBankingModel } from "../../models/UtenteModels";
import { Input } from 'antd'
import { TTFormItem } from '../shared/TTFormItem'
import { TTSelect } from '../shared/TTSelect'
import { RouteComponentProps, withRouter } from 'react-router'
import container from '../../wires/Bootstrapper'
import SERVICE_IDENTIFIER from '../../wires/Identifiers'
import { renderSelectKeyValue, renderSelectList, renderSelectModel } from '../shared/SelectOptionRenderUtils'
import { KeyValueModel } from '../../models/ModelBase'
import { IAppContext } from '../AppContext'
import { IConfigurazioneService } from '../../services/ConfigurazioneService'
import { YapilyLookup, YapilyLookupModel } from '../../models/YapilyModels';
import { IYapilyService } from '../../services/YapilyService';
import Column from 'antd/lib/table/Column';
import { ModalYapilyLookup } from './ModalYapilyLookup';
import { ModalImportYapilyLookup } from './ModalImportYapilyLookup';
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { ai } from '../../TelemetryService';



class PageYapilyLookupState extends YapilyLookupModel {
    isLoading: boolean = false
    ModalVisible: boolean = false
    ModalData: YapilyLookup
    ModalImportVisible: boolean = false
}

export class PageYapilyLookupComp extends React.Component<RouteComponentProps, PageYapilyLookupState> {

    service: IYapilyService
    constructor(props) {
        super(props)

        this.service = container.get(SERVICE_IDENTIFIER.YAPILY_SERVICE)
        this.state = new PageYapilyLookupState()
    }

    componentDidMount() {
        this.search()
    }

    search = async () => {
        let resp = await this.service.Search()
        this.setState(resp)
    }

    onAddClick = () => {
        this.toggleModal(true)
    }

    onEdit = (record: YapilyLookup) => {
        this.toggleModal(true, record)
    }

    toggleModal = (visible: boolean, data?: YapilyLookup) => {
        this.setState({ ModalVisible: visible, ModalData: data })
    }

    onDelete = async (record: YapilyLookup) => {
        Modal.confirm({
            title: "Elimina",
            content: "Eliminare questo record?",
            onOk: async () => {
                let resp = await this.service.Delete(record.Id)
                if (resp.IsValid == true)
                    this.search()
            }
        })
    }

    getColumn = () => {
        return (
            <Column fixed="left" title="" dataIndex="Id" render={(_, record: YapilyLookup) =>
                [
                    <Button type="primary" key="delete-lookup-cc" icon={<DeleteOutlined />} size="small" onClick={() => this.onDelete(record)} />,
                    <Button type="primary" key="edit-lookup-cc" icon={<EditOutlined />} size="small" onClick={() => this.onEdit(record)} />
                ]
            } />
        )
    }

    importLookup = (visible: boolean) => {
        this.setState({ ModalImportVisible: visible })
    }

    uploadEmbeddedFlow = async () => {
        debugger

        this.setState({isLoading:true})
        let res = await this.service.UpdateEmbeddedFlow()
        if (res.IsValid == true)
            this.search()
        this.setState({ isLoading: false })
    }

    toggleImportModal = (visible: boolean) => {
        this.setState({ ModalImportVisible: visible })
    }

    exportLookup = () => {
        this.service.ExportYapilyLookup()
    }

    renderCheck = (data: boolean) => {
        if (data) return (<CheckCircleTwoTone twoToneColor="green" />)
        return (<CloseCircleTwoTone twoToneColor="red" />)
    }

    renderEmbeddedFlow = (data: boolean) => {
        if (data) return (<CheckCircleTwoTone twoToneColor="green" />)
        return (<CloseCircleTwoTone twoToneColor="red" />)
    }

    render() {
        return (
            <Spin indicator={<LoadingOutlined style={{ fontSize: 36 }} spin />} spinning={this.state.isLoading}>
                <PageHeader title="" extra={[
                    <Button type="primary" key="add-lookup" icon={<PlusOutlined />} onClick={() => this.onAddClick()}>Crea</Button>,
                    <Button type="primary" key="download-lookup" icon={<DownloadOutlined />} onClick={() => this.exportLookup()}>Scarica lookup</Button>,
                    <Button type="primary" key="upload-embeddedflow" icon={<RedoOutlined />} onClick={() => this.uploadEmbeddedFlow()}>Aggiorna feature banche</Button>,
                    <Button type="primary" key="import-lookup" icon={<ImportOutlined />} onClick={() => this.importLookup(true)}>Importa lookup</Button>
                ]}>
                    <Table
                        scroll={{ x: 2000}}
                        dataSource={this.state.Items}
                        rowKey={it => it.Id}>
                        {this.getColumn()}
                        <Column title="Banca" dataIndex="Banca" fixed="left" />
                        <Column title="Abi" dataIndex="Abi" fixed="left" />
                        <Column title="Id Istituto private" dataIndex="IdIstituto" fixed="left" />
                        <Column title="Id Istituto business" dataIndex="IdIstitutoBusiness" fixed="left" />
                        <Column title="CBI Globe Gateway" dataIndex="IsCbi" render={(value: boolean) => this.renderCheck(value)}  />
                        <Column title="Embedded Flow" dataIndex="IsEmbeddedFlow" render={(value: boolean) => this.renderCheck(value)}  />
                        <Column title="PSU-ID Obbligatorio" dataIndex="PsuIdMandatory" render={(value: boolean) => this.renderCheck(value)}  />
                        <Column title="PSU-CORPORATE-ID Obbligatorio" dataIndex="PsuCorporateIdMandatory" render={(value: boolean) => this.renderCheck(value)}  />
                        <Column title="PSU-IP-ADDRESS Obbligatorio" dataIndex="PsuIpAddressMandatory" render={(value: boolean) => this.renderCheck(value)}  />
                        <Column title="ACCOUNT" dataIndex="HasAccount" render={(value: boolean) => this.renderCheck(value)}  />
                    </Table>

                    {this.state.ModalVisible ?
                        <ModalYapilyLookup
                            data={this.state.ModalData}
                            visible={this.state.ModalVisible}
                            closeModal={() => this.toggleModal(false)}
                            do={() => this.search()} /> : <></>
                    }
                    {this.state.ModalImportVisible ?
                        <ModalImportYapilyLookup
                           
                            visible={this.state.ModalImportVisible}
                            closeModal={() => this.toggleImportModal(false)}
                            do={() => this.search()} /> : <></>
                    }
                </PageHeader>
                
            </Spin>
        )
    }
}

export const PageYapilyLookup = withRouter(withAITracking(ai.reactPlugin, PageYapilyLookupComp,"PageYapilyLookup"))